import { useState } from "react";

import { ExternalUser, SalesPerson } from "models/customers/customers";
import UserServiceExpandableListItem from "./UserServiceExpandableListItem";
import WizardModule from "../wizardmodule/WizardModule";

import "./UserServiceEdit.scss";

type Props = {
  isInternal: boolean;
  showSaveButton?: boolean;
  title: string;
  users: ExternalUser[] | SalesPerson[];
  fpConfig: any;
  disableFp?: boolean;
  onSetFpService: (customerChoice: string, userId: string) => void;
  onToggleService: (userId: string, serviceId: string, value: boolean) => void;
  onToggleChildServices: (
    userId: string,
    serviceIds: string[],
    value: boolean
  ) => void;
  collapsed?: boolean;
  onSaveClick?: () => void;
};

export default function UserServiceEdit({
  isInternal,
  showSaveButton,
  title,
  users,
  fpConfig,
  disableFp,
  onSetFpService,
  onToggleService,
  onToggleChildServices,
  collapsed,
  onSaveClick
}: Props) {
  const [editingUser, setEditingUser] = useState<ExternalUser|SalesPerson |undefined>(undefined);

  const handleEditClick = (user:ExternalUser|SalesPerson) => {
    if (editingUser === user) {
        setEditingUser(undefined);
    } else {
        setEditingUser(user);
    }
  };

  const infoText = users.length === 0 && (
    <div className="infoText">
      Inga kundanvändare är tillagda på kunden ännu.
    </div>
  );

  const info = isInternal
    ? "Här kan du välja vilka behörigheter varje specifik medarbetare i kundteamet ska ha tillgång till gällande digitala tjänster. Alla i kundteamet ska ha tillgång till alla mappar i dokumentarkivet och du kan inte välja bort det som du valde i steg två Digitala tjänster & dokument."
    : "Här väljer du vilka specifika behörigheter varje kundanvändare ska ha. Var nog med att kontrollera att behörigheterna blir rätt för varje kundanvändare så dom inte får åtkomst till material dom inte ska kunna ha tillgång till.";

  return (
    <WizardModule
      showSaveButton={showSaveButton}
      onSaveClick={onSaveClick}
      collapsed={collapsed}
      moduleTitle={title}
      info={info}
    >
      <>
        {infoText}
        <ul className="listWrapper">
          {users.map((user) => {
            return (
              <UserServiceExpandableListItem
                key={user.id}
                user={user}
                editing={!!editingUser && (editingUser.email === user.email)}
                onEditClick={handleEditClick}
                isInternal={isInternal}
                fpConfig={fpConfig}
                onSetFpService={onSetFpService}
                onToggleService={onToggleService}
                onToggleChildServices={onToggleChildServices}
                disableFp={disableFp}
              />
            );
          })}
        </ul>
      </>
    </WizardModule>
  );
}
